<script>

    import dayjs from "dayjs";
    import Easepick from '../lib/easepick-svelte/Easepick.svelte'
    import {createEventDispatcher, onMount} from "svelte";
    import PropertySelection from "./propertyselection.svelte"
    import Search from "./utils/search.svelte"

    const dispatch = createEventDispatcher();

    export let selected = "all";
    let dateRange = {
        'start': false,
        'end': parseInt(new Date().getTime() / 1000),
        'selected': selected
    };

    export let showSearch = false;
    export let startDate;
    export let allowDropdown = true;
    export let keyword;


    let calendarContainer;
    let calendarLitepicker;

    let easepickIsShown;

    let triggerCalendar = () => {

        selected = 'lightpicker';

        calendarLitepicker.open();
        easepickIsShown = true;

    };


    let closeCalendar = () => {

        if (easepickIsShown) {
            calendarLitepicker.close();
            easepickIsShown = false;
        }

    };

    let calendarDatesSelected = (evt) => {

        dateRange['start'] = parseInt(new Date(evt.detail['startDate']).getTime() / 1000);
        dateRange['end'] = parseInt(new Date(evt.detail['endDate']).getTime() / 1000);

        eventDispatcher();

    };

    let listOptionSelected = (value) => {

        selected = value;

        dateRange['selected'] = value;

        switch (value) {

            case '7d':
                dateRange['start'] = parseInt(new Date(new Date().setDate(new Date().getDate() - 7)).getTime() / 1000);
                break;

            case '1m':
                dateRange['start'] = parseInt(new Date(new Date().setMonth(new Date().getMonth() - 1)).getTime() / 1000);
                break;

            case '3m':
                dateRange['start'] = parseInt(new Date(new Date().setMonth(new Date().getMonth() - 3)).getTime() / 1000);
                break;

            case '6m':
                dateRange['start'] = parseInt(new Date(new Date().setMonth(new Date().getMonth() - 6)).getTime() / 1000);
                break;

            case '1y':
                dateRange['start'] = parseInt(new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getTime() / 1000);
                break;

            default:

                dateRange['start'] = startDate;
        }

        eventDispatcher();

    };

    let eventDispatcher = () => {

        dispatch('dates', dateRange);
    };

    let searchEventDispatcher = () => {

        dispatch('keywordsearch', keyword);
    };



</script>


<!--<svelte:window on:click|stopPropagation={closeCalendar}/>-->


<header>

    <PropertySelection on:propertychange/>

    <div id="date-selection">

        <div id="date-selector">

            <ul>

                <li class:active={selected === 'all'} on:click={() => listOptionSelected('all')} data-range="all">Alle</li>
                <li class:active={selected === '7d'} on:click={() => listOptionSelected('7d')} data-range="7d">1W</li>
                <li class:active={selected === '1m'} on:click={() => listOptionSelected('1m')} data-range="1m">1M</li>
                <li class:active={selected === '3m'} on:click={() => listOptionSelected('3m')} data-range="3m">3M</li>
                <li class:active={selected === '6m'} on:click={() => listOptionSelected('6m')} data-range="6m">6M</li>
                <li class:active={selected === '1y'} on:click={() => listOptionSelected('1y')} data-range="1y">1J</li>

                <li
                        id="datepicker"
                        class:active={selected === 'lightpicker'}
                        on:click|self={() => triggerCalendar()}>

                    <img
                            src="images/icon-calendar.svg"
                            on:click|self={() => triggerCalendar()} />

                    <div
                            id="calendar-container"
                            bind:this={calendarContainer}
                            style="display: none;">

                        <Easepick
                                bind:this={calendarLitepicker}
                                bind:element={calendarContainer}
                                on:selected={calendarDatesSelected}
                                calendars={2}
                                firstDay={1}
                                autoApply={false}
                                css={['/css/easepick.css']}
                        />

                    </div>

                </li>

            </ul>
        </div>
    </div>

    {#if showSearch}

        <Search
            keyword={keyword}
            on:searchevent
            allowDropdown={allowDropdown}
        />

    {/if}


</header>

<style>

    header {
        position: absolute;
        display: flex;
        justify-content: space-between;
        width: calc(100vw - 9.26vh - 8.23vh);
        left: 9.26vh;
        padding: 3.7vh 4.53vh;
        z-index: 999;
    }

    #date-selection {
        position: absolute;
        display: flex;
        flex-direction: column;
        top: 2.08vw;
        left: 50%;
        transform: translate(-50%, 0);
    }

    #date-selection #date-selector {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    #date-selection ul {
        display: flex;
        flex-direction: row;
        padding: 0.28vh 0.18vh;
        margin: 0;
        list-style-type: none;
        background-color: #FFFFFF;
        border-radius: 2.84vh;
    }

    #date-selection ul li,
    #date-selection #datepicker {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 7.41vh;
        height: 3.7vh;
    }

    #date-selection ul li {
        font-family: 'Roboto', sans-serif;
        font-weight: 400;
        font-size: 1.78vh;
        color: #000000;
        border-radius: inherit;
        user-select: none;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    #date-selection ul li.active,
    #date-selection ul li:hover {
        color: white;
        background-color: #3247E5;
    }

    #date-selector #datepicker img {
        height: 3vh;
        transition: all 0.3s ease;
    }

    #date-selector #datepicker.active img,
    #date-selector #datepicker:hover img {
        filter: invert(100%) sepia(100%) saturate(0%) hue-rotate(201deg) brightness(106%) contrast(106%);
    }

    :global(#datepicker .easepick-wrapper) {
        position: absolute;
        color: inherit;
        max-width: none;
        /*z-index: 3001;*/
        top: 6vh;
        left: 50%;
        right: auto;
        display: flex;
        /*background-color: white;*/
        transform: translate(-50%, 0);
        font-family: 'Roboto', sans-serif;
        border: 0;
        border-radius: 1.39vh;
    }

</style>
